import React, { Fragment } from "react";
import TestHeader from "../../container/testHeader/testHeader";
import { HelperContext } from "../../store/helperStore";

export default function GetTest({
  questions,
  actualTestFormat, // this data coming from the backend
  testFormat, //define by us
  Component,
}) {
  const { helperC, dispatchHelper } = HelperContext();
  const { runningQuesId } = helperC;
  console.log(
    "is condition by pass",
    actualTestFormat === testFormat ? questions : " no"
  );

  const getFNMix = () => {
    const fnData = questions.find((ques) => runningQuesId === ques.id);
    return fnData;
  };
  console.log(questions);

  return (
    /* condition to enter in test case according to test formate*/
    actualTestFormat === testFormat && (
      <>
        {actualTestFormat === "visual_facename_mix" ? ( // special case face name mix test
          <>
            {console.log("is this are working")}
            <Component
              question={
                helperC.testType === "CALIBRATION" ? getFNMix() : questions
              }
            />
          </>
        ) : actualTestFormat === "simple_reaction_sound" ? (
          <Component />
        ) : (
          questions.map((launchedTest, index) => {
            return (
              <Fragment key={index}>
                {/* {runningQuesId === launchedTest.id && ( */}
                {runningQuesId.toString() === launchedTest.id.toString() && (
                  <div key={index} className="test-block">
                    <Fragment>
                      <TestHeader
                        sectionName={launchedTest.section_name}
                        question={launchedTest}
                        questions={questions}
                        index={index}
                      />
                      
                      <div className="test-body">
                        <Component
                          question={launchedTest}
                          questions={questions}
                          index={index}
                        />
                      </div>
                    </Fragment>
                  </div>
                )}
              </Fragment>
            );
          })
        )}
      </>
    )
  );
}
